import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AgGridTenantGroupRoleSettings } from './AgGridTenantGroupRoleSettings';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { TenantDto, TenantGroupRoleDto, TenantGroupRoleUserDto, TenantResolved } from 'projects/shared/src/lib/models/TenantDto';
import { TenantPermissionDto } from 'projects/shared/src/lib/models/PermissionForCreationDto';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { PermissionsService } from 'projects/shared/src/lib/services/permissions.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { TenantGrouprolesButtonRendererComponent } from '../tenant-grouproles-button-renderer/tenant-grouproles-button-renderer.component';
import { MatDialog } from '@angular/material/dialog';
import { AddTenantGrouproleDialogComponent } from '../add-tenant-grouprole-dialog/add-tenant-grouprole-dialog.component';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { AssignTenantGrouproleDialogComponent } from '../assign-tenant-grouprole-dialog/assign-tenant-grouprole-dialog.component';
import { AuditFilter } from 'projects/shared/src/lib/models/AuditFilter';

@Component({
  selector: 'tenant-grouproles',
  templateUrl: './tenant-grouproles.component.html',
  styleUrls: ['./tenant-grouproles.component.scss']
})
export class TenantGrouprolesComponent implements OnInit {

  @Input('tenant') tenant!:TenantDto;
  @Input('user') user!:UserDto;
  
  @ViewChild('matRef') matRef!: MatSelect;

  rowData: TenantGroupRoleDto[] = [];
  permissions: TenantPermissionDto[] = []

  groupRoles:TenantGroupRoleDto[] = [];
  groupRolesToAssign:TenantGroupRoleDto[] = [];
  groupRolesToDisplay:TenantGroupRoleDto[] = [];
  userForm!: FormGroup;

  fromSideNav = false;
  selectTGRforuser = false;
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridTenantGroupRoleSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  _tenantName!: string;

    _userRoles:string[] = [];
  
    emptyGuid = '00000000-0000-0000-0000-000000000000';
    auditFilter: AuditFilter = {
      type: "TGR",
      action: "",
      //action: "UpdTGR",
      userId: this.emptyGuid,
      //userId: "70f4174f-17c5-454f-aa52-0b70ea3a00d7",
      projectId: this.emptyGuid,
      //projectId: "2828a047-6761-4e5e-b990-84224f1cc591",
      groupRoleId: this.emptyGuid,
      //groupRoleId: "bc77f89c-3a81-4dba-8051-3c415cb81edf",
      createdBy: this.emptyGuid, //creator_Id
      //createdBy: "fdfc41f0-6ede-4fcc-a727-3eb938ee4749", //creator_Id
      startTime: "",
      //startTime: "12.05.2025, 16:42:28.050",
      endTime: ""
      //endTime: "20.05.2025, 15:03:20.432"
    };
  
  
  
  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public translate:TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    private permissionService: PermissionsService) { }

    ngOnInit(): void {
      //console.log("tenant-grouproles user = ", this.user)
      this.fromSideNav = (this.tenant == null) && (this.user == null);
      this.selectTGRforuser = (this.user != null);

      this._tenantName = (this.tenant != null)? this.tenant.name : this.tenantService.tempTenantName;
      this.tenantService.tempTenant = this._tenantName;
      this.tenantService.tempUserId = (this.user != null)?this.user.id:"";
      //localStorage.setItem('current-tenant-db', this._tenantName);

      this._tenantName = this.tenantService.currentTenantName;
      if (this._tenantName != null){
      // force creating new token? no, cause temp. tokenMap is empty ==> new token
        this.tenantService.getToken(this._tenantName, false).subscribe({
          next: (token) => {
            var tenantRoles = this.tenantService.getTenantRoles(token);
            //console.log("------> tenant roles: ", tenantRoles);
            if (tenantRoles != null){
              tenantRoles.forEach((role: string)=> {
                if (role != "" && !this._userRoles.includes(role)) this._userRoles.push(role);
                // test
                // if (role == 'MANAGE_USERS') self._manageUsers = true;
                // if (role == 'MANAGE_PROJECTS') self._manageProjects = true;
              });
            }
            //console.log("------> user roles: ", self._userRoles);
          }
        });
      }


      this.filter = new GenericFilter();
      this.aggridSettings = new AgGridTenantGroupRoleSettings(this.translate, !this.selectTGRforuser);
  
      this.frameworkComponents = {
        buttonRenderer: TenantGrouprolesButtonRendererComponent
      }
  
      //this.gridOptions = agGridUsersSettings;
      this.gridOptions = this.aggridSettings.agGridTenantGroupRoleSettings;
  

      if (this.selectTGRforuser) {
  
       this.createUserForm();
      }
 
    }

    removeElementFromObjectArray(key: string) {
      this.groupRolesToDisplay.forEach((value,index)=>{
          if(value.id == key) this.groupRolesToDisplay.splice(index,1);
      });
    } 

    createUserForm() {
  
      let roles:TenantGroupRoleDto[] = [];
      this.userForm = this.formBuilder.group({
//        userRoles:[roles, [Validators.required]],
        userRoles:[roles],
      });
  
    }
  

onGridReady(params: any) {
  this.gridApi = params.api;
  this.gridApi.sizeColumnsToFit();

  const datasource = {
    rowCount: 0,
    getRows: (dsParams: IGetRowsParams) => {

      // API ist garantiert vorhanden
      this.gridApi.showLoadingOverlay();
      this.isLoadingResults = true;

      this.filter.className = 'TenantProject';
      this.filter.startRow = dsParams.startRow;
      this.filter.endRow = dsParams.endRow;
      this.filter.sortItems = dsParams.sortModel;
      this.filter.clientFilters = dsParams.filterModel;

      if (this.selectTGRforuser) {

        this.tenantService
          .getUserTenantGroupRoles(this.tenantService.tempTenantName, this.user.id, this.filter)
          .subscribe({
            next: (grouproles) => {

              const rows = grouproles.slice(dsParams.startRow, dsParams.endRow);
              const lastRow = grouproles.length <= dsParams.endRow ? grouproles.length : -1;

              dsParams.successCallback(rows, lastRow);

              this.isLoadingResults = false;
              this.gridApi.hideOverlay();

              // weitere Daten laden
              this.tenantService
                .getTenantGroupRoles(this.tenantService.tempTenantName, this.filter)
                .subscribe({
                  next: (groupRoleDtos: any) => {
                    this.groupRolesToDisplay = groupRoleDtos;

                    rows.forEach((role) => {
                      this.removeElementFromObjectArray(role.id);
                    });
                  }
                });
            },

            error: (error: any) => {
              this.isLoadingResults = false;
              this.gridApi.hideOverlay();

              this.notificationService.error(
                `${this.translate.data["ERROR"]}`,
                `${this.translate.data["USERRETRIEVALERROR"]}`
              );

              this.notificationService.info("", error.error.developerMessage.Message);
            }
          });

      } else {

        this.tenantService
          .getTenantGroupRoles(this._tenantName, this.filter)
          .subscribe({
            next: (grouproles) => {

              const rows = grouproles.slice(dsParams.startRow, dsParams.endRow);
              const lastRow = grouproles.length <= dsParams.endRow ? grouproles.length : -1;

              dsParams.successCallback(rows, lastRow);

              this.isLoadingResults = false;
              this.gridApi.hideOverlay();
            },

            error: (error: any) => {
              this.isLoadingResults = false;
              this.gridApi.hideOverlay();

              this.notificationService.error(
                `${this.translate.data["ERROR"]}`,
                `${this.translate.data["USERRETRIEVALERROR"]}`
              );

              this.notificationService.info("", error.error.developerMessage.Message);
            }
          });
      }
    }
  };

  this.gridApi.setDatasource(datasource);
}


    addTenantGroupRole() {
      const dialogRef = this.dialog.open(AddTenantGrouproleDialogComponent, { width: '800px', data: TenantGroupRoleDto });
        dialogRef.afterClosed().subscribe((result: any) => { 
  
          if (result !== undefined) {
            let tenantGroupRole = new TenantGroupRoleDto;
            tenantGroupRole.name = result.name
            tenantGroupRole.displayName = result.name;
            tenantGroupRole.permissions = result.permissions;
  
            this.tenantService.createTenantGroupRole(this._tenantName, tenantGroupRole).subscribe({
              next: (data) => {
                this.rowData.splice(2, 0, data);
                this.rowData.push(data);
                this.gridApi.refreshInfiniteCache();
                this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEADDED"]}`);
              },
              error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`)
            });
          }
        },
        //error
      );
    }
    
    saveValues(values: any) {

      console.log("values = ", values)
      this.groupRolesToAssign = values;

    }

    add() {
      if (this.userForm.valid) {
        // let data = {roles: this.userForm.value};
        // console.log("-------> selected roles: ", this.groupRolesToAssign)
        this.groupRolesToAssign.forEach((role: TenantGroupRoleDto) => {
          let tenantGroupRoleUser = new TenantGroupRoleUserDto;
          tenantGroupRoleUser.roleId = role.id;
          tenantGroupRoleUser.name = role.name;
          tenantGroupRoleUser.userId = this.user.id;
          tenantGroupRoleUser.userName = this.user.userName;
          this.tenantService.createTenantGroupRoleUser(this._tenantName, tenantGroupRoleUser).subscribe({
            next: (data) => {
              this.rowData.splice(2, 0, role);
              this.rowData.push(role);
              this.gridApi.refreshInfiniteCache();
              this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEASSIGNED"]}`);
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`)
          });



        })
        // let data = {userDto: this.userForm.value, subSquirrels: this.subSquirrels};
        // this._dialogRef.close(this.userForm.value);
      }
      else{
        this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
      }
      //this.userForm.reset({ userRoles: null });
      this.clear();
    }

    assignTGRtoUser() {
      const dialogRef = this.dialog.open(AssignTenantGrouproleDialogComponent, { width: '800px'});
      dialogRef.afterClosed().subscribe((result: any) => { 

        if (result !== undefined) {
          let userDto:UserDto = result.userDto;        
          let groupRolesToAssign = userDto.userRoles;
          groupRolesToAssign.forEach((role: TenantGroupRoleDto) => {
            let tenantGroupRoleUser = new TenantGroupRoleUserDto;
            tenantGroupRoleUser.roleId = role.id;
            tenantGroupRoleUser.name = role.name;
            tenantGroupRoleUser.userId = this.user.id;
            tenantGroupRoleUser.userName = this.user.userName;
            // console.log("-----> tenant-grouproles.assignTGRtoUser(): tenantGroupRoleUser = ", tenantGroupRoleUser)
            this.tenantService.createTenantGroupRoleUser(this._tenantName, tenantGroupRoleUser).subscribe({
              next: (data) => {
                this.rowData.splice(2, 0, role);
                this.rowData.push(role);
                this.gridApi.refreshInfiniteCache();
                this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEASSIGNED"]}`);
              },
              error: (error: any) => {
                this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`)
                console.log("------> error: ", error)
                // if (error.error.status == 404) {
                  this.notificationService.info("", "Benutzer existiert nicht mehr!");
                // }
                // else
                //   // this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`);
                // this.notificationService.info("", error.error.title);
              }
            }); 
          })
      }
    },
      //error
    );
    }
  
    exportAuditData() {
      //this.auditFilter.projectId = this.proj.id;
      this.auditFilter.userId = this.user.id;
      this.tenantService.exportAuditLog(this.tenantService.currentTenantName, this.auditFilter).subscribe({
        next: (response) => {
          //this.isLoadingResults = false;
          //this.isRateLimitReached = true;
        this.notificationService.success("", "Excel Datei wird erstellt und steht in Kürze unter Dateidownload bereit!");
          // console.log("------> response: ", response)
        },
        error: (error: any) => {
          // this.isLoadingResults = false;
          //this.isRateLimitReached = true;
          this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler Audit Log Export")
          console.log("------> error: ", error)
          this.notificationService.info("", error)
        }
      });
    }


    clear() {
      this.matRef.options.forEach((data: MatOption) => data.deselect());
    }
    

  }



